export const setGlobalFilter = (globalFilterState) => {
    return {type: "SET_GLOBAL_FILTER", value: globalFilterState};
};
export const setDefaultGlobalFilter = () => {
    return {type: "SET_DEFAULT_GLOBAL_FILTER"};
};
